import { cn } from '@avanta/shared/utils/cn';
import { AnimatedContainer } from 'components/ui/AnimatedContainer';
import { CONTAINER_LG_MAX_WIDTH } from '../../../styles';
import { type StepProps } from '../../../types';
import { DesktopView, MobileView } from './components';

export const ConfirmationStep = ({ handleBack }: StepProps): React.ReactElement => (
  <AnimatedContainer className={cn(CONTAINER_LG_MAX_WIDTH, 'flex pb-8 h-full')}>
    <DesktopView handleBack={handleBack} />
    <MobileView handleBack={handleBack} />
  </AnimatedContainer>
);
